<script setup lang="ts">
type Props = {
  options: Record<string, any>[];
  disabled?: boolean;
  displayKey?: string;
  valueKey?: string;
  pickable?: boolean;
};

const {
  options,
  disabled,
  displayKey = 'label',
  valueKey = 'value',
  pickable: isPickerVisible = true,
} = defineProps<Props>();

const modelValue = defineModel<number | string>('modelValue', {
  required: false,
});
</script>

<template>
  <div :class="$style.radioGroup">
    <label
      v-for="option in options"
      :key="option[valueKey]"
      :class="[
        $style.radioLabel,
        {
          [$style.isDisabled]: disabled,
          [$style.isPickable]: isPickerVisible,
        },
      ]"
    >
      <input
        v-model="modelValue"
        :class="$style.radioInput"
        :disabled="disabled"
        type="radio"
        :value="option[valueKey]"
      />
      <span
        v-if="isPickerVisible"
        :class="$style.radioCustom"
      ></span>

      <slot
        name="item"
        v-bind="{ option }"
      >
        <span>{{ option[displayKey] }}</span>
      </slot>
    </label>
  </div>
</template>

<style module lang="postcss">
.radioGroup {
  @apply flex gap-5;

  .radioLabel {
    @apply w-full flex items-center cursor-text text-xs md:text-sm text-texts;

    &.isDisabled {
      @apply opacity-60 cursor-not-allowed;
    }

    &.isPickable {
      @apply cursor-pointer;
    }

    .radioCustom {
      @apply min-w-3 min-h-3 md:min-w-4 md:min-h-4 border md:border-2 border-solid border-texts rounded-full mr-2 relative;
    }

    .radioInput {
      @apply hidden;

      &:checked + .radioCustom {
        @apply border-primary;
      }

      &:checked + .radioCustom::after {
        content: '';
        @apply w-1.5 h-1.5 md:w-2 md:h-2 bg-primary rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2;
      }
    }
  }
}
</style>
